import React from "react";
import Grid from "../../../Grid/Grid";
import Button from "../../../core/Button/Button";
import "./home-register.scss";

const HomeRegister = () => {
  return (
    <section className="home-register">
      <Grid addClass="home-register__grid">
        <div className="home-register__container">
          <div className="home-register__wrapper">
            <h2 className="home-register__heading">Create Your Profile</h2>
            <span className="home-register__span">
              We'd love to hear what you think about the platform.
            </span>
            <Button externalLink="https://askthestar.com/reg/" ripple>
              Register Now
            </Button>
          </div>
        </div>
      </Grid>
    </section>
  );
};

export default HomeRegister;
